import { ATTACHMENT_EXTENSIONS } from '@/shared/config';

// The same reading as the server's `path.extname`: a name made only of the extension, such as
// ".pdf", has no extension at all.
export function fileExtension(fileName: string): string {
  const dot = fileName.lastIndexOf('.');
  return dot > 0 ? fileName.slice(dot).toLowerCase() : '';
}

export function hasAllowedAttachmentExtension(fileName: string): boolean {
  return (ATTACHMENT_EXTENSIONS as readonly string[]).includes(fileExtension(fileName));
}
